import z from "zod";

export const CompositionAspectRatioDto = z.union([
  z.literal("16:9"),
  z.literal("9:16"),
  z.literal("1:1"),
]);

export type CompositionAspectRatioDto = z.infer<
  typeof CompositionAspectRatioDto
>;
